var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{
  'cl-form-control-label': true,
  'cl-form-control-label--disabled': _vm.disabled
}},[_vm._t("default"),_vm._t("label",[_c('cl-typography',{attrs:{"component":"span"}},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }